var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vmp-custom-menu-imglink",class:{ 'qr-preview-page': _vm.isSubscribe }},[_c('div',{staticClass:"qr-previewbox"},[_c('div',{staticClass:"qrbox"},[_c('img',{attrs:{"src":_vm.info.imageSrc,"alt":""},on:{"click":_vm.jump}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }